import { Building2, CheckCircle2, Search } from 'lucide-react'
import { CARD_STYLE, COLORS, INPUT_CLASS, INPUT_STYLE } from '../shared'

export default function SelectClient({
  clients,
  loading,
  value,
  search,
  onSearchChange,
  onSelect,
}) {
  const selectedId = value?.id

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-6 sm:gap-8">
      <div className="flex flex-col items-center gap-3 text-center">
        <span
          className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-widest sm:text-[11px]"
          style={{
            background: 'rgba(254, 159, 52, 0.12)',
            border: '1px solid rgba(254, 159, 52, 0.3)',
            color: '#FE9F34',
          }}
        >
          <Building2 className="h-3 w-3" />
          Cliente
        </span>
        <h2
          className="text-2xl font-bold tracking-tight sm:text-4xl"
          style={{ color: COLORS.text, lineHeight: 1.1 }}
        >
          Para qual cliente este agente vai atender?
        </h2>
        <p
          className="max-w-xl text-sm leading-relaxed sm:text-base"
          style={{ color: COLORS.textMuted }}
        >
          Escolha o cliente antes de criar o agente. Assim, os canais e as
          configurações ficam sempre no lugar certo.
        </p>
      </div>

      <div className="flex flex-col gap-3 rounded-2xl p-5 sm:rounded-3xl sm:p-6" style={CARD_STYLE}>
        <label
          className="text-[10px] font-semibold uppercase tracking-wider sm:text-[11px]"
          style={{ color: 'rgba(255,255,255,0.4)' }}
        >
          Selecione um cliente
        </label>
        <div className="relative">
          <Search
            className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2"
            style={{ color: 'rgba(255,255,255,0.35)' }}
          />
          <input
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Buscar cliente"
            className={`${INPUT_CLASS} pl-11`}
            style={INPUT_STYLE}
          />
        </div>

        <div className="max-h-[320px] overflow-y-auto pr-1">
          {loading ? (
            <div className="flex flex-col gap-2">
              {[0, 1, 2].map((item) => (
                <div key={item} className="h-16 animate-pulse rounded-xl bg-white/[0.05]" />
              ))}
            </div>
          ) : clients.length === 0 ? (
            <div className="rounded-xl border border-dashed border-white/[0.12] px-5 py-10 text-center">
              <p className="text-sm font-semibold" style={{ color: COLORS.text }}>
                Nenhum cliente encontrado
              </p>
              <p className="mt-1 text-xs leading-relaxed" style={{ color: COLORS.textMuted }}>
                Crie um cliente primeiro para organizar agentes e canais desde o início.
              </p>
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              {clients.map((client) => {
                const selected = Number(client.id) === Number(selectedId)
                return (
                  <button
                    key={client.id}
                    type="button"
                    onClick={() => onSelect(client)}
                    className="flex w-full items-center gap-3 rounded-xl p-3 text-left transition-all duration-200"
                    style={{
                      background: selected ? 'rgba(173,52,254,0.14)' : 'rgba(255,255,255,0.03)',
                      border: selected
                        ? '1px solid rgba(173,52,254,0.55)'
                        : '1px solid rgba(255,255,255,0.07)',
                    }}
                  >
                    <div
                      className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-xl text-xs font-bold text-white"
                      style={{ background: client.primaryColor || '#AD34FE' }}
                    >
                      {client.logo ? (
                        <img src={client.logo} alt="" className="h-full w-full object-cover" />
                      ) : (
                        client.name?.slice(0, 2)?.toUpperCase()
                      )}
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold" style={{ color: COLORS.text }}>
                        {client.name}
                      </p>
                      <p className="mt-0.5 text-[11px]" style={{ color: COLORS.textMuted }}>
                        {client.isActive === false ? 'Cliente inativo' : 'Pronto para receber agentes'}
                      </p>
                    </div>
                    {selected && <CheckCircle2 className="h-5 w-5 shrink-0 text-[#34FEAD]" />}
                  </button>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
